<template>
  <div class="container">
    <!-- <el-empty description="没有配置客服链接！" v-if="!contactLink"></el-empty><div class="contact" v-else><iframe class="iframe" :src="contactLink" frameborder="0" align="middle" width="100%" height="1000px"></iframe></div> -->
    <el-container style="height: 100%; border: 1px solid #eee">
      <el-aside width="300px" style="padding: 10px 0; border-right: 1px solid #ddd; background-color: #fff;">
        <div class="user-list">
          <div class="top">
            <el-input placeholder="请输入内容" prefix-icon="el-icon-search" v-model="searchUser"></el-input>
          </div>
          <div class="list">
            <div v-for="(item, index) in userList" :key="index" class="list-item" :class="{'selected-list': item.memberId == selectedUser.id || item.memberId == blinking }" @click="selectUser(item)">
              <div class="avatar">
                <img class="avatar-pic" src='@/assets/images/avatar.png' />
              </div>
              <div class="username">{{ item.account }}</div>
              <div class="last-msg">{{ handleLastMessage(item.lastMessage) }}</div>
              <div class="time">{{ timeHandle(item.lastMessageTime) }}</div>
            </div>
          </div>
        </div>
      </el-aside>
      <el-container>
        <el-header style="text-align: left;">
          <div class="head-box">
            <div class="user-name">{{ selectedUser.account }}</div>
          </div>
        </el-header>
        <el-main id="chat-content">
          <div class="chat-content">
            <div class="message-outer-box">
              <div v-for="(item, index) in chatList" :key="index">
                <!-- 对方  v-if="item.sendReceive !== 'send' -->
                <div v-if="item.member == myUserId">
                  <div class="msg-time">
                    {{ timeHandle(item.createTime) }}
                  </div>
                  <div class="word">
                    <img class="avatar-pic" src='@/assets/images/avatar.png' />
                    <div class="info">
                      <div class="info-content" v-if="item.messageType === 'text'" v-html="item.message"></div>
                      <div class="info-content" v-else>
                        <!--                        <img width="200px" height="200px" :src="item.message" />-->
                        <el-image style="width: 200px; height: 200px" :src="item.message" :preview-src-list="[item.message]"></el-image>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- 我的 -->
                <div v-else>
                  <div class="msg-time">
                    {{ timeHandle(item.createTime) }}
                  </div>
                  <div class="word-my">
                    <div class="info">
                      <div class="info-content" v-if="item.messageType === 'text'" v-html="item.message"></div>
                      <div class="info-content" v-else>
                        <!--                        <img width="200px" height="200px" :src="item.message" />-->
                        <el-image style="width: 200px; height: 200px" :src="item.message" :preview-src-list="[item.message]"></el-image>
                      </div>
                    </div>
                    <img class="avatar-pic" src="@/assets/images/avatar.png" />
                  </div>
                </div>
              </div>
            </div>
            <div class="send-box">
              <div class="input-msg-box">
                <el-input type="textarea" :rows="3" placeholder="请输入内容" v-model="messageInfo"></el-input>
                <div class="upload-pic">
                  <el-upload class="upload-input" :action="uploadUrl" :show-file-list="false" :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload" :data="uploadData" :headers="uploadHeader">
                    <el-button size="small">
                      <i class="el-icon-picture el-icon--right"></i>
                    </el-button>
                  </el-upload>
                </div>
              </div>
              <div class="operation-btns">
                <el-button size="small" type="info" @click="clearMessage">清空</el-button>
                <el-button size="small" type="primary" @click="sendMessage">发送</el-button>
              </div>
            </div>
          </div>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import Vue from 'vue'
import {
  getChatList,
  getMessage,
  getChatClientList,
  sendMsg,
  sendPic,
} from "@/api/system/customerService";
import {getToken, getId} from "@/utils/auth";
import socketApi from "@/utils/socket/chatSocket";

// Vue.prototype.$socketApi = socketApi;

export default {
  // $socketApi: socketApi,
  data() {
    return {
      blinking: "", // 闪烁
      selected: false,
      heartbeatBlinking: 0,
      myUserId: getId(),
      socket: socketApi,
      websocketUrl: 'wss://manager.tumm08.com/api/websocket',
      total: 0,
      loading: true,
      searchUser: "",
      uploadUrl: 'https://manager.tumm08.com/api/system/kefu/send/picMsg',
      token: "",
      selectedUser: {
        uname: "",
        id: "",
        topicId: "",
      },
      // customerServiceList: [],
      messageInfo: "",
      userList: [], // 左侧用户列表
      chatList: [],
      contactLink: "",
      getMessageTimer: null,
      socketData: {
        formatDate: new Date().getTime(),
        lockReconnect: false, //是否真正建立连接
        timeout: 58 * 1000, //58秒一次心跳
        timeoutObj: null, //心跳心跳倒计时
        serverTimeoutObj: null, //心跳倒计时
        timeoutNum: null, //断开 重连倒计时
      },
      dialogImageUrl: '',
      dialogVisible: false,
      disabled: false,

    };
  },
  watch: {
    // "$route.query.RouterName"(val) {
    //   this.initRouteComponent();
    // },
    "heartbeatBlinking"() {
      console.log('更新左侧')
      this.chatClientList();
    },
  },
  created() {
    // this.getChatList();
    this.chatClientList();
  },
  mounted() {
    this.getMessageList();
    this.token = "Bearer " + getToken();

    // 初始化 socket
    this.initWebSocket();
  },
  beforeDestroy() {
    console.log("清理chat定时器");
    clearTimeout(this.getMessageTimer);

    this.clearBlinking();
    //this.socket.closeWebSocket();
  },
  destroyed() {
    this.socket.closeWebSocket(); //离开路由之后断开websocket连接
  },
  computed: {
    uploadData() {
      return {
        topicId: this.selectedUser.topicId,
      }
    },
    uploadHeader() {
      return {
        Authorization: this.token,
      }
    }
  },
  methods: {
    // ------------------- start -------------------
    closeSocket() {
      if (this.socket) {
        this.socket.closeWebSocket();
        this.socket = null;
      }
    },
    // socket
    initWebSocket() {
      // 初始化
      console.log('initWebSocket');
      // 建立socket连接， 并设置socket信息返回接受函数
      //this.socket.initSocketUrl("?userId=" + this.myUserId + "&isKefu=1&token=" + getToken());
      let wsUrl = `${this.websocketUrl}?userId=${this.myUserId}&isKefu=1&token=${getToken()}`
      this.socket.initWebSocket(wsUrl, this.getSocketResult);
      /// onOpen 发送
      this.websocketSend({
        type: 0,
      })
    },
    // 发送socket信息
    websocketSend(data) {
      //console.log('websocket send:' + JSON.stringify(data))
      this.socket.sendSock(data);
    },
    // ----------------------------- socket  --------------
    // 左侧用户列表
    chatClientList() {
      //console.log("我的ID:" + this.myUserId);
      this.loading = true;
      getChatClientList().then((res) => {
        const data = res.data
        const list = []
        for (let i = 0; i < data.length; i++) {
          const element = data[i];
          list.push({
            memberId: element.memberId,
            topicId: element.topicId,
            uname: element.uname,
            lastMessage: element.lastMessage,
            lastMessageTime: element.lastMessageTime,
            account: element.account,
          })
        }
        this.userList = list
        this.loading = false;
      });
    },

    // 对话列表
    getMessageList(once) {
      try {
        //console.log("获取对话列表");
        const memberId = this.selectedUser.id;
        if (memberId) {
          getMessage(memberId).then((res) => {
            if (res.data) {
              this.chatList = res.data;
              this.$nextTick(() => {
                this.scrollToBottom()
              })
              if (res.data[0]) {
                this.selectedUser.topicId = res.data[0].topicId
              }
            }
          });
        }
        if (once) {
          return;
        }
        //this.getMessageTimer = setTimeout(this.getMessageList, 5000);
      } catch (err) {
        console.log("get message error");
      }
    },

    // 左侧栏选择用户
    selectUser(item) {
      this.selectedUser.uname = item.uname;
      this.selectedUser.account = item.account;
      this.selectedUser.id = item.memberId;
      this.selectedUser.topicId = item.topicId;
      //console.log(this.selectedUser.topicId);

      // 取消闪烁
      this.clearBlinking();

      // 获取消息列表
      this.getMessageList(true);
    },
    clearBlinking() {
      if (this.heartbeatBlinking !== 0) {
        //("取消闪烁:" + this.heartbeatBlinking);
        this.blinking = "";
        clearInterval(this.heartbeatBlinking);
      }
    },
    // 发消息
    sendMessage() {
      if (!this.selectedUser.topicId || !this.messageInfo) {
        return;
      }
      // http 方式
      // let obj = {
      //   topicId: this.selectedUser.topicId,
      //   content: this.messageInfo,
      // };
      // sendMsg(obj).then((res) => {
      //   if (res.code == 200) {
      //     this.getMessageList(true);
      //   }
      // });

      // socket 方式
      let obj = {
        msg: this.messageInfo,
        type: 1,
        data: {
          topicId: this.selectedUser.topicId,
          msgType: 1,
          isCustomer: 1,
          userId: this.myUserId,
          from: this.myUserId,
          to: this.selectedUser.id,
          content: this.messageInfo,
        }
      };
      //console.log("发文本消息:" + JSON.stringify(obj));
      this.websocketSend(obj);

      // 追加到对话
      this.addToConversationList("text", "send", this.myUserId, this.messageInfo);
      this.messageInfo = "";
    },

    clearMessage() {
      this.messageInfo = "";
    },

    scrollToBottom() {
      const element = document.querySelector("#chat-content")
      element.scrollTop = element.scrollHeight
    },
    // 图片发送成功
    handleAvatarSuccess(res, file) {
      console.log(file);
      //console.log(JSON.stringify(res));
      // {"msg":"https://bityou.s3.ap-northeast-1.amazonaws.com/chat/Frame1261155800.png","code":200}
      //console.log("图片发送成功返回图片:" + res.msg);
      //this.getMessageList(true);

      // socket 方式
      let obj = {
        msg: res.msg,
        type: 1,
        data: {
          topicId: this.selectedUser.topicId,
          msgType: 2, // 图片
          isCustomer: 1,
          userId: this.myUserId,
          from: this.myUserId,
          to: this.selectedUser.id,
          content: res.msg,
          picUrl: res.msg
        }
      };
      //console.log("发图片消息:" + JSON.stringify(obj));
      this.websocketSend(obj);
      // 追加图片到对话
      this.addToConversationList("img", "send", this.myUserId, res.msg);
    },
    // 追加到对话
    addToConversationList(messageType, sendReceive, memberId, message) {
      let conversation = {
        //id: 1,
        topicId: this.selectedUser.topicId,
        member: memberId,
        sendReceive: sendReceive,
        messageType: messageType,
        message: message,
        createTime: new Date(),
        updateTime: new Date()
      }
      // this.chatList.unshift(conversation);
      this.chatList.push(conversation);
      this.$nextTick(() => {
        this.scrollToBottom()
      });
    },

    beforeAvatarUpload(file) {
      if (!this.selectedUser.topicId) {
        this.$message.error("未选择对话用户");
        return false
      }
      return true;
    },

    // -----------------------------------------------------------------
    handleRemove(file) {
      console.log(file);
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    handleDownload(file) {
      console.log(file);
    },

    // socket信息返回接受函数
    getSocketResult(res) {
      //console.log("socket信息返回接受函数:" + JSON.stringify(res));
      if (res.msg === "pong") {
        return;
      }
      // 播放声音
      let chatNewMsg = document.getElementById('warningAudio2')
      // chatNewMsg.pause()
      if (chatNewMsg !== undefined) {
        chatNewMsg.play()
      }
      //console.log("selectedUser.id=" + this.selectedUser.id, res.data.from)
      let from = res.data.from;

      // 更新到顶部
      this.updateToTop(from, res.msg);

      // 如果接收到的是当前选中的用户
      if (from === this.selectedUser.id) {
        this.addToConversationList(res.data.msgType === 1 ? "text" : "img",
            "send",
            from,
            res.msg
        );
      } else {
        // item 闪烁
        this.heartbeatBlinking = setInterval(() => {
          if (this.blinking === "") {
            this.blinking = from;
          } else {
            this.blinking = "";
          }
        }, 500);
        //console.log("item 闪烁=" + this.heartbeatBlinking)
      }
    },
    // 新来消息时 更新到顶部
    updateToTop(from, newMessage) {
      //console.log('更新到顶部===========from:' + from + ", " + newMessage);
      const list = []
      let newest = null;
      for (let i = 0; i < this.userList.length; i++) {
        const element = this.userList[i];
        let item = {
          memberId: element.memberId,
          topicId: element.topicId,
          uname: element.uname,
          lastMessage: element.lastMessage,
          lastMessageTime: element.lastMessageTime,
          account: element.account,
        };
        if (element.memberId === from) {
          item.lastMessage = newMessage;
          item.lastMessageTime = new Date();
          newest = item;
        } else {
          list.push(item);
        }
      }
      if (newest != null) {
        list.unshift(newest);
      }
      //console.log('list==' + JSON.stringify(list));
      this.userList = list;
    },
    handleLastMessage(msg) {
      if (msg != null && msg !== '' && msg.length > 30) {
        return msg.substring(0, 30) + '...';
      }
      return msg;
    },
    // -----------------------------------------------------

    timeHandle(num) {
      //时间戳数据处理
      let date = new Date(num);
      //时间戳为10位需*1000，时间戳为13位的话不需乘1000
      let y = date.getFullYear();
      let MM = date.getMonth() + 1;
      MM = MM < 10 ? "0" + MM : MM; //月补0
      let d = date.getDate();
      d = d < 10 ? "0" + d : d; //天补0
      let h = date.getHours();
      h = h < 10 ? "0" + h : h; //小时补0
      let m = date.getMinutes();
      m = m < 10 ? "0" + m : m; //分钟补0
      let s = date.getSeconds();
      s = s < 10 ? "0" + s : s; //秒补0
      return y + "-" + MM + "-" + d + " " + h + ":" + m + ":" + s;
    },
  },
};
</script>
<style lang="scss" scoped>
.el-upload--picture-card {
  background-color: #fbfdff;
  border: 1px dashed #c0ccda;
  border-radius: 6px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  width: 72px !important;
  height: 72px !important;
  cursor: pointer;
  line-height: 80px !important;
  vertical-align: top;
}

.container {
  // display: flex;
  width: 100%;
  height: calc(100vh - 100px);

  .contact {
    position: relative;
    width: 100%;
    height: 100%;

    .iframe {
      width: 100%;
      height: 100%;
    }
  }

  .avatar-pic {
    width: 28px !important;
    height: 28px !important;
  }

  .user-list {
    .top {
      padding: 0 10px;
    }

    .list {
      margin-top: 10px;
    }

    .list-item {
      position: relative;
      height: 60px;
      padding: 0 10px;
      border-bottom: 1px solid #e6e9ee;
      cursor: pointer;

      &.selected-list {
        background-color: #c7e8ff;
        animation: none; /* 取消闪烁 */
      }

      @keyframes blink {
        0% { background-color: #fff; }
        50% { background-color: #c7e8ff; }
        100% { background-color: #fff; }
      }
      .blink {
        animation: blink 1s infinite;
      }
      .selected {
        background-color: #c7e8ff;
        animation: none; /* 取消闪烁 */
      }

      .avatar,
      .username,
      .last-msg,
      .time {
        position: absolute;
      }

      .avatar {
        top: 20px;
        left: 10px;
      }

      .username {
        top: 15px;
        left: 50px;
        font-weight: 900;
        font-size: 12px;
      }

      .last-msg {
        top: 30px;
        left: 50px;
        font-size: 12px;
      }

      .time {
        top: 15px;
        right: 10px;
        font-size: 11px;
      }
    }
  }

  .head-box {
    .user-name {
      font-weight: 900;
      font-size: 14px;
      padding: 20px 0;
      border-bottom: 1px solid #e6e9ee;
    }
  }

  .chat-content {
    margin-top: 10px;
    width: 100%;
    overflow: auto;

    .message-outer-box {
      min-height: 500px;
    }

    // background: darkorange;


    .msg-time {
      text-align: center;
      font-size: 11px;
    }

    .word {
      display: flex;
      margin-bottom: 10px;

      .info {
        // width: 47%;
        margin-left: 20px;

        .info-content {
          word-break: break-all;
          // max-width: 45%;
          display: inline-block;
          padding: 10px;
          font-size: 13px;
          background: #fff;
          position: relative;
          background: #e6e9ee;
          border-radius: 4px;
        }

        //小三角形
        .info-content::before {
          position: absolute;
          left: -8px;
          top: 8px;
          content: "";
          border-right: 10px solid #e6e9ee;
          border-top: 8px solid transparent;
          border-bottom: 8px solid transparent;
        }
      }
    }

    .msg-area {
      height: 500px;
    }

    .word-my {
      display: flex;
      justify-content: flex-end;
      margin-bottom: 10px;

      .info {
        width: 90%;
        // margin-left: 10px;
        text-align: right;
        // position: relative;
        display: flex;
        align-items: flex-end;
        flex-wrap: wrap;
        flex-direction: column;

        .info-content {
          word-break: break-all;
          padding: 10px;
          font-size: 13px;
          margin-right: 10px;
          position: relative;
          background: #e6e9ee;
          text-align: left;
          border-radius: 4px;
        }

        //小三角形
        .info-content::after {
          position: absolute;
          right: -8px;
          top: 8px;
          content: "";
          border-left: 10px solid #e6e9ee;
          border-top: 8px solid transparent;
          border-bottom: 8px solid transparent;
        }
      }
    }

    .send-box {
      position: relative;

      .upload-pic {
        position: absolute;
        right: 2px;
        top: 2px;
      }

      .operation-btns {
        margin-top: 10px;
        text-align: right;
      }
    }
  }
}

</style>
